export default {
  form: {
    font_family: {
      label: 'Schriftfamilie',
    },
    header: {
      label: 'Kopfzeile',
      placeholder: 'Kopfzeile',
    },
    sub_header: {
      label: 'Unter Kopfzeile',
      placeholder: 'Unter Kopfzeile',
    },
    qr_code_header: {
      label: 'UI-Box-Kopfzeile',
      placeholder: 'UI-Box-Kopfzeile',
    },
    qr_code_description: {
      label: 'UI box Beschreibung',
      placeholder: 'UI box Beschreibung',
    },
    footer: {
      label: 'Text in der Fußzeile',
      placeholder: 'Fußzeilentext eingeben',
    },
    url_type: {
      label: 'URL',
      placeholder: 'URL auswählen',
    },
    url: {
      placeholder: 'www.example.com',
    },
    primary_color: {
      label: 'Primäre Farbe',
    },
    background_color: {
      label: 'Hintergrundfarbe',
    },
    cover_image: {
      label: 'Titelbild',
    },
    logo: {
      label: 'Logo',
    },
    logo_zoom: {
      label: 'Logo-Zoom',
    },
  },
  toasts: {
    failed_to_load_data: 'Türsticker konnte nicht geladen werden',
  },
};
